import { render, staticRenderFns } from "./StatisticReports.vue?vue&type=template&id=644f3a82&"
import script from "./StatisticReports.vue?vue&type=script&lang=ts&"
export * from "./StatisticReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports